import { render, staticRenderFns } from "./top-sheet.vue?vue&type=template&id=dc2039d4"
import script from "./top-sheet.vue?vue&type=script&lang=js"
export * from "./top-sheet.vue?vue&type=script&lang=js"
import style0 from "./top-sheet.vue?vue&type=style&index=0&id=dc2039d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports